// Flag to ensure initialization occurs only once
var initialized = false;

// Function to initialize the application
function initialize() {
    var layerState = {
        "fitted-sheet": null,
        "quilt-cover": null,
        "pillowcase": null,
        "euro-pillowcase": null,
        "flat-sheet": null,
        "pillowcase-2": null,
        "feature-pillowcase": null, // Add this line
        "feature-pillowcase-2": null, // Add this line
      "valance": null,
    };

    // Function to refresh all image layers based on the current state
    function refreshImageLayers() {
        var imageContainer = document.querySelector('.media-viewer');
        if (!imageContainer) {
            return;
        }

        // Clear existing images
        imageContainer.innerHTML = '';

        // Define a layer order with corresponding z-index values
        const layerOrder = {
            "fitted-sheet": 1,
            "quilt-cover": 2,
            "euro-pillowcase": 3,
            "pillowcase-2": 4,
            "pillowcase": 5,
            "flat-sheet": 6,
            "feature-pillowcase": 7, 
            "feature-pillowcase-2": 8,
            "valance": 9,
        };

        // Loop through each layer in the predefined order and add to container
        Object.keys(layerState).sort((a, b) => layerOrder[a] - layerOrder[b]).forEach(layer => {
            if (layerState[layer]) {
                var img = document.createElement('img');
                img.src = layerState[layer];
                img.setAttribute('data-name', layer);
                img.style.position = 'absolute';
                img.style.top = '0';
                img.style.left = '0';
                // Set z-index based on predefined layer order
                img.style.zIndex = layerOrder[layer];
                img.setAttribute('role', 'presentation');
                img.style.display = 'block';
                imageContainer.appendChild(img);
            }
        });

        // Add or remove the "builder" class based on the presence of any selected layer
        let hasActiveLayer = Object.values(layerState).some(value => value !== null);
        if (hasActiveLayer) {
            imageContainer.classList.add("builder");

            // Add spacer class to product-media container on mobile
            const productMedia = document.getElementById('product-media');
            if (productMedia && window.innerWidth <= 768) {
                productMedia.classList.add('has-builder-active');
            }

            // Initialize mobile sticky behavior when builder class is added
            if (window.innerWidth <= 768 && !imageContainer.dataset.stickyInitialized) {
                initializeMobileStickyBehavior(imageContainer);
                imageContainer.dataset.stickyInitialized = 'true';
            }
        } else {
            imageContainer.classList.remove("builder");
            imageContainer.classList.remove("make-sticky");

            // Cleanup sticky behavior when builder is inactive
            if (window.innerWidth <= 768) {
                cleanupMobileStickyBehavior(imageContainer);
                imageContainer.dataset.stickyInitialized = 'false';
            }
        }

    }
 
    // Adjusted function to update or create image based on radioButton state
    function updateOrCreateImage(radioButton, addImage) {
    var variantId = radioButton.getAttribute('gpo-data-variant-id');
    var variantDataDiv = document.querySelector('.variant-data[data-variant-id="' + variantId + '"]');

    if (variantDataDiv) {
        var isSecondOption = radioButton.name.includes("Second");
        var isFeaturePillowcase = radioButton.name.includes("Feature Pillowcases");
        var dataDivSelector = isSecondOption ? 
            'div[data-pillowcase-2], div[data-feature-pillowcase-2]' : 
            'div[data-fitted-sheet], div[data-quilt-cover], div[data-pillowcase], div[data-euro-pillowcase], div[data-flat-sheet], div[data-feature-pillowcase], div[data-valance]';
        var dataDiv = variantDataDiv.querySelector(dataDivSelector);

        if (dataDiv) {
            // Instead of using the first attribute, get the data attribute name directly
            var attributeName = dataDiv.getAttributeNames().find(name => name.startsWith('data-') && name !== 'data-product-name' && name !== 'data-variant-image');
            if (attributeName) {
                // Remove 'data-' prefix to get layer name
                var layerName = attributeName.substring(5);
                
                // Handle feature pillowcase case
                if (isFeaturePillowcase) {
                    layerName = isSecondOption ? 'feature-pillowcase-2' : 'feature-pillowcase';
                }

                if (layerState.hasOwnProperty(layerName)) {
                    layerState[layerName] = addImage ? dataDiv.getAttribute(attributeName) : null;
                    refreshImageLayers();
                    updateTabTextForSelection();
                }
            }
        }
    }
}

    function setupRadioButtons() {
        var radioButtons = document.querySelectorAll('input[type="radio"][data-type="image-swatches"]');
        radioButtons.forEach(function(radioButton) {
            radioButton.addEventListener('change', function() {
                if (radioButton.checked) {
                    // When a radio button is checked, add its corresponding image
                    updateOrCreateImage(radioButton, true);
                } else {
                    // This else block might not be executed as expected due to the nature of radio buttons
                    // Consider implementing a different strategy to determine when a swatch is "deselected"
                    updateOrCreateImage(radioButton, false);
                }
            });
        });
    }

    setupRadioButtons();
}



// Simple helper function for mobile sticky behavior
function initializeMobileStickyBehavior(element) {
    if (!element || window.innerWidth > 768) return;

    // Only calculate original position once (not when already sticky)
    if (!element._originalTop) {
        // Temporarily remove sticky class to get true position
        const wasSticky = element.classList.contains('make-sticky');
        element.classList.remove('make-sticky');

        // Get the true original position
        element._originalTop = element.getBoundingClientRect().top + window.pageYOffset;

        // Restore sticky class if it was there
        if (wasSticky) {
            element.classList.add('make-sticky');
        }
    }

    const originalTop = element._originalTop;

    // Simple scroll handler
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const productMedia = document.getElementById('product-media');

        // If scrolled past the original position, make it sticky
        if (scrollTop > originalTop + 10) { // Small buffer to prevent flickering
            element.classList.add('make-sticky');
            if (productMedia) {
                productMedia.classList.add('sticky-spacer');
            }
        } else {
            // At top of page - return to normal position
            element.classList.remove('make-sticky');
            if (productMedia) {
                productMedia.classList.remove('sticky-spacer');
            }
        }
    }

    // Remove any existing listener
    if (element._scrollHandler) {
        window.removeEventListener('scroll', element._scrollHandler);
    }

    // Store and add new listener
    element._scrollHandler = handleScroll;
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Check initial state
    handleScroll();
}

// Cleanup function
function cleanupMobileStickyBehavior(element) {
    if (!element) return;

    if (element._scrollHandler) {
        window.removeEventListener('scroll', element._scrollHandler);
        element._scrollHandler = null;
    }

    // Clear stored original position
    element._originalTop = null;

    element.classList.remove('make-sticky');

    const productMedia = document.getElementById('product-media');
    if (productMedia) {
        productMedia.classList.remove('sticky-spacer');
    }
}

// Listen for the custom event 'gpoElementChanged'
document.addEventListener('gpoElementChanged', function() {
    if (!initialized) {
        initialize(); // Initialize on first trigger
        markUnavailableSwatches()
        initialized = true; // Prevent further initialization
    }
    // Further logic for handling gpoElementChanged events after initialization, if necessary
});

// Optionally, directly call initialize() if needed immediately without waiting for the event
// This is useful if the event might not fire immediately or under certain conditions
// initialize(); // Uncomment if direct initialization is needed
